const getDate = (type, date) => {
  const now = date === undefined ? new Date() : new Date(date);
  const firstJan = new Date(now.getFullYear(), 0, 1);
  const months = [
    'januari',
    'februari',
    'maart',
    'april',
    'mei',
    'juni',
    'juli',
    'augustus',
    'september',
    'oktober',
    'november',
    'december',
  ];

  const currentDay = now;
  const currentWeek = Math.ceil((((now - firstJan) / 86400000) + firstJan.getDay() + 1) / 7);
  const currentMonth = months[now.getMonth()];

  switch (type) {
  case 'day':
    return currentDay;
  case 'week':
    return currentWeek;
  case 'month':
    return currentMonth;
  }
};

const typesMap = { dag: 'day', week: 'week', maand: 'month' };
const typeOfListToType = typeOfList => typesMap[typeOfList.slice(4)];
const mutateDate = (date, type, offset) => {
  switch (type) {
  case 'day':
    date.setDate(date.getDate() + offset);
    break;
  case 'week':
    date.setDate(date.getDate() + offset * 7);
    break;
  case 'month':
    date.setMonth(date.getMonth() + offset);
    break;
  }
  return date;
};

const formatNumber = number => Number(number).toLocaleString('nl-NL').replace(/,/g, '.');

const formatPricing = number => Number(number).toLocaleString('nl-NL', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  currencyDisplay: 'code',
});

const formatDate = (date, type) => {
  const dateInput = new Date(date);
  const firstJan = new Date(dateInput.getFullYear(), 0, 1);
  const addLeadingZero = input => input.length > 1 ? input : '0' + input;

  const year = date.getFullYear();
  let month = (1 + date.getMonth()).toString();
  month = addLeadingZero(month);
  let week = Math.ceil((((dateInput - firstJan) / 86400000) + firstJan.getDay() + 1) / 7).toString();
  week = addLeadingZero(week);
  let day = date.getDate().toString();
  day = addLeadingZero(day);

  switch (type) {
  case 'day':
    return `${year}-${month}-${day}`;
  case 'week':
    return `${year}${week}`;
  case 'month':
    return `${year}${month}`;
  }
};


const formatDateItemFooter = date => {
  const d = new Date(date);
  const today = new Date(Date.now());
  const newDate = new Date(Date.now());
  const yesterday = new Date(newDate.setDate(newDate.getDate() - 1));
  const months = [
    'jan',
    'feb',
    'maa',
    'apr',
    'mei',
    'jun',
    'jul',
    'aug',
    'sep',
    'okt',
    'nov',
    'dec',
  ];
  const fullDate = (date, minusDay) => {
    const setDate = minusDay ? yesterday : date;
    return `${setDate.getDate()}${setDate.getMonth()}${setDate.getFullYear()}`;
  };

  const fullTime = date => `${('0' + date.getHours()).slice(-2)}:${('0' + date.getMinutes()).slice(-2)}`;

  let returnDate = '';
  if (fullDate(today) === fullDate(d)) {
    returnDate = `vandaag @ ${fullTime(d)}`;
  } else if (fullDate(today, true) === fullDate(d)) {
    returnDate = `gister @ ${fullTime(d)}`;
  } else {
    returnDate = `${d.getDate()} ${months[d.getMonth()]} ${String(d.getFullYear()).slice(-2)} @ ${fullTime(d)}`;
  }
  return returnDate;
};

const isElementInViewport = element => {
  if (element) {
    const rect = element.getBoundingClientRect();
    return rect.bottom > 0 &&
      rect.right > 0 &&
      rect.left < (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */ &&
      rect.top < (window.innerHeight || document.documentElement.clientHeight) /* or $(window).height() */;
  }
};

const adBreakPoint = windowWidth => {
  if (windowWidth < 640) {
    return 'XS';
  } else if (windowWidth > 639 && windowWidth < 970) {
    return 'S';
  } else if (windowWidth > 969 && windowWidth < 1200) {
    return 'M';
  } else if (windowWidth > 1199 && windowWidth < 1700) {
    return 'L';
  } else if (windowWidth > 1699) {
    return 'XL';
  }
};

const strippedContent = content => content  
  .replace(/<[^>]*>?/gm, '')
  .replace(/  +/g, ' ');

const escapeSpecialChars = text => {
  const charsMap = { 
    amp: '&', 
    lt: '<', 
    gt: '>', 
    quot: '"', 
    '#039': '\'',
    '#x27': '\'',
  };
  return text.replace(/&([^;]+);/g, (m, c) => charsMap[c]);
};

const twitchParams = media => {
  const embedSplit = media ? media[0].variants[0].uri.split(':') : null;
  const embedId = embedSplit ? embedSplit[1] : '';
  const liveEmbed = embedSplit 
    ? embedSplit[0] === 'twitch' && embedSplit[1] === 'dumpert'
    : false;  

  return { live: liveEmbed, id: embedId };
};

export {
  getDate,
  formatNumber,
  formatPricing,
  formatDate,
  formatDateItemFooter,
  isElementInViewport,
  adBreakPoint,
  typeOfListToType,
  mutateDate,
  strippedContent,
  escapeSpecialChars,
  twitchParams,
};